import { service } from '@/utils/request'
import constv from '@/config/constv'

class auth {
  static getList (params) { return service.get(constv.AUTH_URL + '/auth_group/getRuleList', { params }) }
  static add (params) { return service.post(constv.AUTH_URL + '/auth_group/addRule', params) }
  static edit (params) { return service.post(constv.AUTH_URL + '/auth_group/editRule', params) }
  static delete (params) { return service.get(constv.AUTH_URL + '/auth_group/delAuthGroup', { params }) }

  // 权限菜单
  static getRoutes () { return service.get(constv.AUTH_URL + '/admin/auth_rule/getRuleList') }
}

export default auth
